import { Mesh, type Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"
import { LightRecon1_LightReconWheel1_GLTF_Model } from "../gltf_models.generated"
import bindReactiveColorToMaterial from "../PlayerThreeObject/bindReactiveColorToMaterial"
import { appGltfLoader } from "./appGltfLoader"
import creaseMeshGeometryNormals from "./creaseMeshGeometryNormals"

export default function makeLightReconWheelScene (
  engine: Engine,
  entity: EntityGraphNode,
  callback: (newGroup: Object3D) => void
): void {
  return appGltfLoader.load(LightRecon1_LightReconWheel1_GLTF_Model, function (ModelObj) {
    const lightReconWheelScene = ModelObj.scene

    // console.log('lightReconWheelScene', lightReconWheelScene)
    // const model = lightReconWheelScene.getObjectByName('LightRecon') as Mesh
    // printObjectHierarchy(lightReconWheelScene)
    lightReconWheelScene.traverse((obj) => {
      if (obj instanceof Mesh) {
        creaseMeshGeometryNormals(obj)
        if (obj.material) {
          const PC = obj.material.userData.PC
          if (PC) {
            bindReactiveColorToMaterial(obj.material, entity.color1)
          }
        }
      }
    })

    callback(lightReconWheelScene)
  })
}
